import * as React from 'react'
import {
    Stack,
    Switch,
    Typography
} from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

import useAutoTranslate from '../hooks/useAutoTranslate'

function FieldHint({ children }) {
    return (
        <Stack direction="row" spacing={0.75} alignItems="flex-start">
            <InfoOutlinedIcon sx={{ mt: '2px', fontSize: 14, color: 'text.secondary' }} />
            <Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1.45 }}>
                {children}
            </Typography>
        </Stack>
    )
}

export default function SpeedSettingsPanel({
    enabled,
    onChange,
    appLanguage = 'en'
}) {
    const t = useAutoTranslate(appLanguage, [
        'Activate Global Effect',
        'Whether to activate global effects (Speed booster)'
    ])

    return (
        <Stack spacing={0.5} sx={{ pt: 0.25 }}>
            <Stack direction="row" spacing={1.2} alignItems="center">
                <Switch
                    checked={Boolean(enabled)}
                    onChange={event => onChange?.(event.target.checked)}
                />
                <Typography variant="body1" sx={{ fontWeight: 700 }}>
                    {t('Activate Global Effect')}
                </Typography>
            </Stack>
            <FieldHint>{t('Whether to activate global effects (Speed booster)')}</FieldHint>
        </Stack>
    )
}
